<template>
  <section class="plausible-privacy">
    <p>
      <strong>{{ $t('cookieConsent.plausibleTitle') }}</strong>
    </p>
    <p>{{ $t('cookieConsent.plausibleDescription') }}</p>
    <ClientOnly>
      <label>
        <input
          type="checkbox"
          data-cy="plausible-opt-out"
          :checked="privacy.optedOut.value"
          @change="privacy.save($event.target.checked)"
        />
        <span>{{ $t('cookieConsent.plausibleOptOut') }}</span>
      </label>
    </ClientOnly>
  </section>
</template>
<script setup>
const privacy = usePlausiblePrivacy();
onMounted(privacy.sync);
</script>
<style scoped>
.plausible-privacy {
  color: var(--privacy-text, #333);
  font-size: 14px;
  line-height: 1.6;
}
p {
  margin-bottom: 8px;
}
label {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding-block: 10px;
  cursor: pointer;
}
input {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 4px;
  accent-color: var(--privacy-accent, #111);
}
input:focus-visible {
  outline: 2px solid var(--privacy-accent, #111);
  outline-offset: 3px;
}
</style>
